import { Component, OnInit, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { DialogService } from '../../_services';
import { DateUtilsService } from '../../_services/dateUtils';
import { DownloadService } from '../../_services/downloadService';

@Component({
  selector: 'app-document-save',
  templateUrl: './app-document-save.component.html',
})
export class AppDocumentSaveComponent implements OnInit {
  urlRetrieved = false;
  @Input() options: any = {
    url: '',
    type: '',
    id: '',
    fileDesc: 'File'
  };
  currentInvoice;

  constructor(
    private navCtrl: NavController,
    private dateUtilsService: DateUtilsService,
    private downloadService: DownloadService,
    private dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.init();
  }

  init() {
  }

  goBack() {
    this.navCtrl.back();  
  }

  saveDocument() {
    const fileName = `${(this.options.id || 'file')}_${this.dateUtilsService.getCurrentTimeStamp()}.pdf` + "";
    this.downloadService.downloadFile(this.options.url, fileName, true, this.options.fileDesc || 'File').then(fileLocation => {
      if (fileLocation) {
        this.dialogService.showInfoAlert(`Successfully saved at ${fileLocation}`);
      }
    });
  }

}

